var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.$route.query.name,"left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{attrs:{"id":"MyViewerDiv"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }